<template>
  <div>
    <el-row :gutter="24">
      <el-col :xs="24" :sm="10">
        <p><b>Введите номер СТС</b></p>
        <el-form-item
          prop="sts"
          :rules="{
            required: true,
            message: 'Введите номер СТС автомобиля',
            trigger: 'blur',
          }"
        >
          <el-input
            v-model="returnData.sts"
            placeholder="Введите номер СТС"
            :disabled="readonly"
            @change="changed"
          />
        </el-form-item>
      </el-col>
      <el-col
        :xs="24"
        :sm="6"
        :style="isMobile ? '' : 'display: block !important'"
      >
        <p><b>Дата выдачи СТС</b></p>
        <el-form-item
          prop="sts_date"
          :rules="{ validator: checkDate, trigger: 'blur' }"
        >
          <el-input
            v-model="returnData.sts_date"
            v-mask="'##.##.####'"
            masked="true"
            :placeholder="getYear()"
            :disabled="readonly"
            @change="changed"
          />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="5">
        <p><b>Марка авто</b></p>
        <el-form-item
          prop="mark"
          :rules="{
            required: true,
            message: 'Заполните марку автомобиля',
            trigger: 'blur',
          }"
        >
          <el-input
            v-model="returnData.mark"
            placeholder="Марка автомобиля"
            :disabled="readonly"
            @change="changed"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :xs="24" :sm="10">
        <p><b>Введите VIN номер</b></p>
        <el-form-item prop="vin">
          <el-input
            v-model="returnData.vin"
            placeholder="Введите VIN номер"
            maxlength="17"
            minlength="17"
            show-word-limit
            :disabled="readonly"
            @change="changed"
          />
          <a v-if="vinIsEmpty" href="#" @click.prevent="setDevaultVIN">
            VIN номер отсуствует
          </a>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { DEFAULT_VIN_VALUE } from '@/datas/consts'
import {
  checkYear,
  getNow,
  getYear,
  isAfterDay,
  isValidDate,
} from '@/helpers/date'
import { defaultDate } from '@/datas/DateFormats'
import mixinMain from '../Mixins/main'

export default {
  name: 'StsTruck',
  mixins: [mixinMain],
  data() {
    return {
      returnData: {
        sts: '',
        mark: '',
        sts_date: '',
        vin: '',
      },
    }
  },
  computed: {
    vinIsEmpty() {
      return !this.returnData.vin || !String(this.returnData.vin).trim().length
    },
  },
  methods: {
    getYear() {
      return `01.01.${getYear()}`
    },
    setDevaultVIN() {
      this.returnData.vin = DEFAULT_VIN_VALUE
    },
    checkDate(rule, value, callback) {
      if (!value) {
        callback(new Error('Укажите дату выдачи'))
      } else if (value.length < 10) {
        callback(new Error('Введите дату полностью'))
      } else {
        const currentDay = getNow(defaultDate)
        const afterDateMoment = isAfterDay(currentDay)

        if (
          afterDateMoment(value) ||
          !isValidDate(value) ||
          !checkYear(value)
        ) {
          callback(new Error('Дата указана с ошибкой'))
        }
      }
      callback()
    },
  },
}
</script>
